import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Props {
	onSuccess?: (noteId: string) => void;
  onError?: (res: AxiosError) => void;
}

export const useDuplicateNote = ({
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onDuplicateNote,
    ...rest
	} = useMutation({
		mutationFn: async (noteId: string) => {
      return await axios.get(`/notes/${noteId}/duplicate`);
		},
		onSuccess: ({ data: { note } }) => {
      if (onSuccess)
        onSuccess(note.id);
    },
    onError
	});

	return { onDuplicateNote, ...rest };
};
